export default "__VITE_ASSET__CKSh126p__"